import { Outlet } from 'react-router'

import { Sidebar } from '../AppBar/Sidebar'
import { LayoutStyles } from './LayoutStyles'

export const AppLayout = () => {
    return <LayoutStyles leftNode={<Sidebar />} rightNode={<Outlet />} />
}
